/* Copyright 2022-2024 VMware, Inc. All rights reserved. VMware Confidential */

export class IconLabelInfo {
    constructor(public label: string,
                public shape: string = '',
                public type: string = '',
                public solid: boolean = false) {
    }
}
